import PropTypes from 'prop-types';

import UnitatsEspecialitzades from '../../UnitatsEspecialitzades/UnitatsEspecialitzades';

const UnitatsListingTemplate = ({ items, isEditMode }) => (
  <div className="listing variation-unitats">
    <UnitatsEspecialitzades items={items} editPreview={isEditMode} />
  </div>
);

UnitatsListingTemplate.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
  isEditMode: PropTypes.bool,
};

UnitatsListingTemplate.defaultProps = {
  items: [],
  isEditMode: false,
};

export default UnitatsListingTemplate;
